import { track } from "../track";

export const trackSettingsView = () => track({ event: "settings_view" });
